module.exports = __webpack_public_path__ + "img/Cookie_1_resize_09.f937d0b3.png";